module.exports = __webpack_public_path__ + "static/Wererat-05d02be3de46b55461b1811defd95063.jpg";